import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Icon, message, Upload } from 'antd';
import * as csv from 'csvtojson';
import { withTranslation } from 'react-i18next';

import { Loading } from '../../../components/loading';

const BatchLoader = ({ t, csvOptions, onLoad }) => {
  const [loading, setLoading] = useState(false);

  const handleUpload = (file) => {
    setLoading(true);
    const reader = new FileReader();

    reader.onload = async ({ target: { result } }) => {
      try {
        const options = {
          delimiter: 'auto',
          ...csvOptions,
        };
        const csvData = await csv(options).fromString(result);
        if (onLoad) {
          setLoading(false);
          onLoad(csvData, result);
        }
      } catch (error) {
        console.error('ERROR: batchLoader: onload()', error); // eslint-disable-line no-console
        message.error(t('error.loading_file'));
        setLoading(false);
      }
    };

    reader.readAsBinaryString(file);

    return false; // prevent remote call
  };

  return (
    <Loading spinning={loading}>
      <Upload.Dragger accept=".csv" multiple={false} beforeUpload={handleUpload}>
        <p className="ant-upload-drag-icon">
          <Icon type="inbox" />
        </p>
        <p className="ant-upload-text">{t('upload.tip')}</p>
        <p className="ant-upload-hint">{t('upload.csv')}</p>
      </Upload.Dragger>
    </Loading>
  );
};

BatchLoader.propTypes = {
  csvOptions: PropTypes.object,
  onLoad: PropTypes.func,
  t: PropTypes.func,
};

export default withTranslation()(BatchLoader);
